"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LinkedInIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.93 12.93h-2.075V9.68c0-.774-.015-1.77-1.08-1.77-1.08 0-1.246.843-1.246 1.715v3.305H6.454V6.249h1.992v.912h.028c.277-.525.954-1.079 1.965-1.079 2.102 0 2.49 1.384 2.49 3.183v3.665zM4.114 5.335a1.204 1.204 0 110-2.408 1.204 1.204 0 010 2.408zM3.076 12.93h2.076V6.249H3.076v6.68zM13.964 1H2.034C1.463 1 1 1.452 1 2.01v11.98c0 .557.463 1.01 1.033 1.01h11.93c.572 0 1.037-.453 1.037-1.01V2.01C15 1.451 14.535 1 13.964 1z",
    clipRule: "evenodd"
  })))
});
LinkedInIcon.displayName = 'LinkedInIcon';
var _default = exports.default = LinkedInIcon;